import { ENUM__error_type } from './ENUM__error_type';
import { IAssertPayload } from './i_assert_payload';
import { assert_array_includes, assert_type_enum, assert_type_string } from './utils_asserts';

export function assert_object_param_enum<T extends Record<string, string | number>>(
  target: object,
  param_name: string,
  enum_object: T,
  assert_payload: IAssertPayload = {},
): T[keyof T] {
  assert_object_param(target, param_name, assert_payload);

  let value = (target as any)[param_name];

  assert_type_enum(value, enum_object, { param_name, ...assert_payload });

  return value;
}

export function assert_object_param_string<T extends object>(target: T, param_name: string, assert_payload: IAssertPayload = {}): string {
  assert_object_param(target, param_name, assert_payload);

  let value = (target as any)[param_name];

  assert_type_string(value);

  return value;
}

export function assert_object_param(target: object, param_name: string, assert_payload: IAssertPayload = {}) {
  assert_payload = { assert_type: ENUM__error_type.VALIDATION_ITEM_NOT_FOUND, param_name, ...assert_payload };

  let keys = Object.keys(target);

  assert_array_includes(keys, param_name, assert_payload);

  return (target as any)[param_name];
}
